/**
 * @packageDocumentation
 * @module      ParentTestResult.ts
 * @description Represents the result of a parent test with sub-tests and aggregation logic
 * @copyright   Copyright © 2026 Siemens Healthineers. All rights reserved.
 */
import { TestStatus } from './TestStatus';
export class ParentTestResult {
    /**
     * Creates a new ParentTestResult instance
     * @param id - Unique identifier for the parent test
     * @param name - Human-readable name of the parent test
     */
    constructor(id, name) {
        /**
         * Current execution status of this test
         */
        this.status = TestStatus.PENDING;
        this.id = id;
        this.name = name;
    }
    markAsPassed() {
        this.status = TestStatus.PASS;
        this.endTime = Date.now();
    }
    markAsFailed() {
        this.status = TestStatus.FAIL;
        this.endTime = Date.now();
    }
    markAsSkipped() {
        this.status = TestStatus.SKIPPED;
        this.endTime = Date.now();
    }
    getAggregatedStatus() {
        return this.status;
    }
    /**
     * Mark the parent test as started
     */
    markAsStarted() {
        this.startTime = Date.now();
    }
    /**
     * Mark the parent test as completed
     */
    markAsCompleted() {
        this.endTime = Date.now();
    }
}
//# sourceMappingURL=ParentTestResult.js.map